export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Solo efectivo en el restaurante. No se acepta pago con tarjeta.',
  },
};
